export default __webpack_public_path__ + "static/media/1920x900 voh live 202110.3f65ea87.jpg";